import { strings as stringsI18n } from 'src/translations/i18n';

export const capitalize = (text) => text[0].toUpperCase() + text.slice(1);
export const strings = stringsI18n;
